<template>
    <div class="about">
        <a href="index.html"><img class="logo" src="/assets/ceo/logo_hotel.png" style="margin-bottom: 0;" height="60" alt="Logo"></a>
        <div v-if="text!=null" v-html="text[currentLanguage]"></div>
    </div>
</template>
<script>
    export default {
        data : function(){
            return {
                text : null
            }
        },
        computed : {
            currentLanguage : function(){
                return  this.$language;
            }
        },
        created : function(){
            var self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                if( self.$store.getters.config!=null )
                {
                    self.text = self.$store.getters.config.footerText;
                }
            });
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                self.text = self.$store.getters.config.footerText;
            });
        },
        beforeDestroy : function(){
            this.unsubscribe();
        }
    }
</script>


// WEBPACK FOOTER //
// Description.vue?86dea5c8